import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/banners/banner-01.png'
import _imports_1 from '@/assets/banners/banner-02.png'
import _imports_2 from '@/assets/banners/banner-03.png'
import _imports_3 from '@/assets/banners/banner-04.png'


const _hoisted_1 = {
  class: "home-section",
  id: "vs-home-header"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Banner 1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Banner 2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Banner 3"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Banner 4"
}, null, -1)

import { ObCarousel } from "@/libs/components";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(ObCarousel), {
      "number-of-items-per-screen": 1,
      "transition-speed": 8000,
      "enable-transition": "",
      "disabled-scroll": "",
      "is-banner": ""
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    })
  ]))
}
}

})